module.exports = __webpack_public_path__ + "static/media/what-new-banner-desktop.ee590013.jpg";